import {CALL_API} from '../../middleware/api'
import queryString from 'query-string'

// 我参加的流程
export const MY_INVOLVED_TASK_REQUEST = 'MY_INVOLVED_TASK_REQUEST'
export const MY_INVOLVED_TASK_SUCCESS = 'MY_INVOLVED_TASK_SUCCESS'
export const MY_INVOLVED_TASK_FAILURE = 'MY_INVOLVED_TASK_FAILURE'

// page=1
export function getMyInvolved(params) {
	return {
		[CALL_API]: {
			types: [MY_INVOLVED_TASK_REQUEST, MY_INVOLVED_TASK_SUCCESS, MY_INVOLVED_TASK_FAILURE],
      endpoint: `/workflow/history/my-involved`,
      methods: 'POST',
      params
		}
	}
}

export default (params) => {
	return (dispatch, getState) => {
		return dispatch(getMyInvolved(params))
	};
};


// WEBPACK FOOTER //
// ./src/action/workflow/myInvolved.js